// ── lineBetRows — spread/total → detailed BetRow builders ───────────
//
// Shared by SpreadTotalSection (its Detailed view) and GameLinesSection
// (its Game Lines detailed table) so both surfaces build the SAME synth
// GameRows from a period's spread/total line arrays. Presentation only:
// each row is a synth GameRow (via synthesize.ts) plus which single
// outcome GameRows should render. No market/pricing logic lives here.

import { synthesizeFromSpread, synthesizeFromTotal } from '../SpreadsTotals/synthesize';
import type { GameEventRow, GameRow, TeamSide } from '../ValueDashboard/types';

/** One renderable bet line = a synth GameRow + the single outcome to show. */
export interface LineBetRow {
  synth: GameRow;
  singleSide: TeamSide;
}

/** Detailed spread rows: one per line, favored (YES / covers) side only, with
 *  the sentence label "CODE wins by over N" the detailed table uses — the
 *  abbreviated "CODE −N" form is synthesizeFromSpread's compact default. */
export function buildSpreadBetRows(event: GameEventRow): LineBetRow[] {
  return event.spreads.map((line) => {
    const synth = synthesizeFromSpread(event, line);
    const favCode = line.favored === 'away' ? event.awayCode : event.homeCode;
    const label = `${favCode} wins by over ${Math.abs(line.line)}`;
    if (line.favored === 'away') synth.awayName = label;
    else synth.homeName = label;
    return { synth, singleSide: line.favored };
  });
}

/** Detailed total rows: one per line, Over (away slot) side. */
export function buildTotalBetRows(event: GameEventRow): LineBetRow[] {
  return event.totals.map((line) => ({
    synth: synthesizeFromTotal(event, line),
    singleSide: 'away' as TeamSide,
  }));
}
